import type { HubModule } from "core-fe-lib/components-shadcn/shell/types";
import { creditRoutes } from "./routes";
import { getCreditLinks } from "./links";
import enUS from "./i18n/en-US";
import fr from "./i18n/fr";

export interface CreditModuleOptions {
  requiredFeature?: string;
  adminOnly?: boolean;
  landingPath?: string;
  landingPriority?: number;
}

export function createCreditModule(opts: CreditModuleOptions = {}): HubModule {
  return {
    id: "credit",
    name: "Credit",
    requiredFeature: opts.requiredFeature ?? "credit",
    adminOnly: opts.adminOnly ?? true,
    landingPath: opts.landingPath ?? "/credit/balances",
    landingPriority: opts.landingPriority ?? 90,
    routes: (layouts) => creditRoutes(layouts.MainLayout),
    navLinks: (ctx) => getCreditLinks(ctx.t),
    messages: { "en-US": enUS, fr },
  };
}
